export const REFINERY_COLORS ={
    IRPC : '#0066cc',
    SPRC : '#ffb44d',
    TOP : '#ff99cc',
    PTTGC : '#66CCFF',
    ESSO : '#ff6666',
    BCP : '#009999',
    ALL : 'grey',
    OTHER: "#000"
  };